// src/oura/components/newscan/OpenDraftList.tsx
//
// The open New scan drafts as rows: the business name (or the site), when it
// was started, and Continue. Shown under the Website field and above the
// businesses list. Continue covers the whole row (22 Oct 2026).

import { FilePenLineIcon } from "lucide-react";
import type { ScanDraftListItem } from "@service/aeo/scanDraftTypes";
import { ListRow, PillButton, ROW_STRETCH } from "@oura/ui";
import { agoText } from "@oura/docs/format";
import { OPEN_DRAFTS } from "@oura/newscan/copy";

export function OpenDraftRows({ drafts, onContinue }: { drafts: ScanDraftListItem[]; onContinue(id: string): void }) {
    return (
        <div>
            {drafts.map((d) => {
                const name = d.businessName || d.domain;
                const ago = agoText(d.createdAt);
                return (
                    <ListRow
                        key={d.id}
                        lead="icon"
                        icon={<FilePenLineIcon aria-hidden size={14} className="text-gray-400" />}
                        title={name}
                        sub={d.businessName ? d.domain : undefined}
                        meta={ago ? OPEN_DRAFTS.started(ago) : undefined}
                        stackMeta
                        stretch
                        right={
                            <PillButton size="sm" className={ROW_STRETCH} aria-label={OPEN_DRAFTS.continueLabel(name)} onClick={() => onContinue(d.id)}>
                                {OPEN_DRAFTS.continue}
                            </PillButton>
                        }
                        data-draft-row={d.id}
                    />
                );
            })}
        </div>
    );
}
